import { api } from "./api";

export const apiJourney = {
  getJourneyDiaryDetail: (params) => {
    return api.get("web/journey_diary_dailies/filter", params);
  },

  getJourneys: (filter, page, size = 10) =>
    api.post("web/contracts/filter", {
      filter,
      page,
      size,
      sort_by: ["-from_datetime", "code"],
    }),

  getFilterOption: () => {
    return api.get("web/journey_diary_dailies/get_filter_options");
  },

  createJourneyDiaryDaily: (payload) => {
    return api.post(
      "web/journey_diary_dailies/create_or_update_blank_journey_diary_daily",
      { ...payload }
    );
  },

  deleteJourneyDiary: (jdd_id) => {
    return api.delete(`web/journey_diary_dailies/delete?jdd_id=${jdd_id}`);
  },

  editAppDiary: (payload) => {
    return api.put("web/journey_diary_dailies/edit_app_diary", { ...payload });
  },

  updateDiaryDriverless: (payload) => {
    return api.put("web/journey_diary_dailies/update_without_driver_diary", {
      ...payload,
    });
  },

  exportJourneyDiary: (filter, fileName = "Nhật ký hành trình") =>
    api.getExcel("web/export/diaries", { filter, fileName }),

  exportJourneyDiaryPdf: (filter, fileName = "Nhật ký hành trình") =>
    api.getPdf("web/export/diaries", { filter, fileName }),

  lockingEdit: (payload) => {
    return api.post("web/journey_diary_dailies/create_or_update_diaries_lock", {
      ...payload,
    });
  },

  fetchSuggestCustomer: ({ name, contract_id }) =>
    api.get("web/member-customers/suggestion-member-customer", {
      name,
      contract_id,
    }),
};
